import { useMutation } from "@tanstack/react-query";

import { type FreedompayPaymentVoidRequestPayload } from "~/types/events";

import { awaitNativeEventOnce } from "../use-native-event-promise/use-native-event-promise";

import { POI_TIMEOUT_MS } from "./constants";

const VOID_POI_PAYMENT_MUTATION_KEY = "freedompay-void-payment";

export const useVoidPoiPayment = () => {
  return useMutation({
    mutationKey: [VOID_POI_PAYMENT_MUTATION_KEY],
    mutationFn: (args: FreedompayPaymentVoidRequestPayload) => {
      return awaitNativeEventOnce({
        timeoutMs: POI_TIMEOUT_MS,
        successEvent: "FREEDOMPAY_PAYMENT_VOID_SUCCESS",
        errorEvent: "FREEDOMPAY_PAYMENT_VOID_ERROR",
        sendEvent: "FREEDOMPAY_PAYMENT_VOID_REQUEST",
        payload: args
      });
    }
  });
};
